<div class="wrapper-nav">
    <div class="nav-header">
        <div [uiSref]="homeState" class="logo" [class.hideLogo]="collapsed">
            <img class="img" src="./assets/images/logo-public.svg" alt="Logo"/>
        </div>
        <div class="menu-toggle-wrapper">
            <a class="menu-toggle lnr lnr-menu" (click)="onMenuToggle()"></a>
        </div>
    </div>

    <div class="nav-wrapper">
        <nav class="main-navigation" *ngIf="links">
            <ng-template ngFor let-link [ngForOf]="links">
                <ng-template ngIf [ngIf]="link.state && link.visible">
                    <a class="link" uiSref="{{link.state}}" uiSrefActive="active" (click)="onItemClick()">
                        <span class="icon lnr {{link.className}}">
                            <span *ngIf="'lnr-calendar-full' === link.className && storage?.travelCounter"
                                                                         class="circle-notification">{{storage?.travelCounter}}</span>
                        <span *ngIf="'lnr-bubble' === link.className && storage?.chatCounter"
                                                                         class="circle-notification">{{storage?.chatCounter}}</span>
                        </span>

                        <span class="text">{{link.text}}</span>
                    </a>
                </ng-template>
                <ng-template ngIf [ngIf]="!link.state">
        <span (click)="toggleSubMenu(link)" class="link">
          <span class="icon lnr {{link.className}}"></span>

          <span class="text text-sub">{{link.text}}</span>
          <span class="lnr lnr-chevron-right" [class.rotate]="link.isSubOpened"></span>
        </span>
                    <div [class.opened]="link.isSubOpened" [ngClass]="['sub-wrapper', link.subClass]">
                        <ng-template ngFor let-sub [ngForOf]="link.sub">
                            <a class="link sub" uiSref="{{sub.state}}"
                               [class.active]="sub.states.indexOf(currentState) >= 0"
                               (click)="onItemClick()">
                                <span class="text">{{sub.text}}</span>
                            </a>
                        </ng-template>
                    </div>
                </ng-template>
            </ng-template>
        </nav>
    </div>
    <div *ngIf="!links" class="navigation-loader loader">
        <span class="lnr lnr-sync"></span>
    </div>
</div>
